<nb-card>
  <nb-card-header></nb-card-header>
  <nb-card-body>
    <div>
      <h1>{{title}}</h1>
      <p>{{message}}</p>
      <div>
        <button (click)='cancel()' class='margin-bottom-1' fullWidth nbButton outline shape='semi-round'>
          {{ 'BUTTONS.NO' | translate }}
        </button>
        <button (click)='confirm()' class='margin-bottom-1' fullWidth nbButton shape='semi-round'>
          {{ 'BUTTONS.YES' | translate }}
        </button>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer></nb-card-footer>
</nb-card>
